import { getIntlLocale } from '@/shared/i18n';

const formatMessageDisplayDateTime = (date: Date | null | undefined): string => {
  if (!date) {
    return '';
  }

  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const isToday = date >= startOfToday;
  if (isToday) {
    return new Intl.DateTimeFormat(getIntlLocale(), {
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  const startOfThisWeek = new Date(startOfToday);
  startOfThisWeek.setDate(startOfToday.getDate() - startOfToday.getDay());

  const isThisWeek = date >= startOfThisWeek && !isToday;
  if (isThisWeek) {
    return new Intl.DateTimeFormat(getIntlLocale(), {
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  const isThisYear = date.getFullYear() === now.getFullYear();
  if (isThisYear) {
    return new Intl.DateTimeFormat(getIntlLocale(), {
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  return new Intl.DateTimeFormat(getIntlLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export { formatMessageDisplayDateTime };
